<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar :background-color="sidebarBackground">
      <div class="logo-home">
        <img :src="appLogo" />
      </div>
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Accueil',
            icon: 'ni ni ni-shop text-gray',
            path: '/menu',
          }"
        />
        <!-- v-if="amIVisible('Dashboard')" -->
        <sidebar-item
          :link="{
            name: 'Tableau de bord',
            icon: 'ni ni-tv-2 text-gray',
            path: '/dashboard',
          }"
        />

        <sidebar-item
          :link="{
            name: 'Utilisateurs',
            icon: 'ni ni-circle-08 text-gray',
            path: '/tablesuser',
          }"
        />
        <sidebar-item
          :link="{
            name: 'Clients',
            icon: 'ni ni-circle-08 text-gray',
            path: '/tablesclient',
          }"
        />
        <!-- <sidebar-item :link="{name: 'Produits', icon: 'ni ni ni-shop text-gray', path: '/listeproduit'}"/> -->
        <!-- v-if="amIVisible('Articles')" -->
        <sidebar-item
          :link="{
            name: 'Articles',
            icon: 'ni ni-ungroup text-gray',
            path: '/listeproduit',
          }"
        />
        <!-- v-if="amIVisible('Caisse')" -->
        <sidebar-item
          :link="{
            name: 'Caisse',
            icon: 'ni ni-ungroup text-gray',
            path: '/caisse/' + getDefaultClient(),
          }"
        />
        <!-- v-if="amIVisible('Historique caisse')" -->
        <sidebar-item
          :link="{
            name: 'Historique Caisse',
            icon: 'ni ni-ungroup text-gray',
            path: '/caissehistory',
          }"
        />
        <!-- v-if="amIVisible('Retours')" -->
        <sidebar-item
          :link="{
            name: 'Retours',
            icon: 'ni ni ni-archive-2 text-gray',
            path: '/retours',
          }"
        />
        <!-- v-if="amIVisible('Paiements')" -->
        <sidebar-item
          :link="{
            name: 'Paiements',
            icon: 'ni ni ni-archive-2 text-gray',
            path: '/payments',
          }"
        />
        <!-- v-if="amIVisible('Historique')" -->
        <sidebar-item
          :link="{
            name: 'Historique',
            icon: 'ni ni ni-archive-2 text-gray',
            path: '/historique',
          }"
        />
        <sidebar-item
          :link="{
            name: 'Paramètrage produit',
            icon: 'ni ni-tv-2 text-gray',
            path: '/sp',
          }"
        />
        <sidebar-item
          :link="{
            name: 'Paramètrage',
            icon: 'ni ni-tv-2 text-gray',
            path: '/appsettings',
          }"
        />
        <div @click="logout()">
          <sidebar-item
            :link="{
              name: 'Se déconnecter',
              icon: 'ni ni ni-button-power text-gray',
              path: '#',
            }"
          />
        </div>
        <!-- <div
          style="width:100%;display:flex;flex-flow:column nowrap;justify-content:center;align-items:center;margin-top:25px;"
        >
          <div class="download-apk"></div>
          <div class="download-apk-txt">Télécharger votre application Android</div>
        </div> -->
        <div
          style="
            position: fixed;
            bottom: 10px;
            left: 30px;
            font-size: 15px;
            font-weight: bold;
          "
        >
          2021 © Ntech
        </div>
      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
        <div class="search-prod">
          <SearchProduct ref="lookForProduct" />
        </div>

        <!--  <content-footer v-if="!$route.meta.hideFooter"></content-footer> -->
      </div>
    </div>
  </div>
</template>
<script>
import DashboardNavbar from "./DashboardNavbar.vue";
//import ContentFooter from './ContentFooter.vue';
import { FadeTransition } from "vue2-transitions";
import SearchProduct from "../views/Produit/SearchProduct";
import { EventBus } from "@/events/event-bus";
import constants from "@/mixins/constants";
export default {
  components: {
    DashboardNavbar,
    // ContentFooter,
    FadeTransition,
    SearchProduct,
  },
  mixins: [constants],
  data() {
    return {
      sidebarBackground: "vue", //vue|blue|orange|green|red|primary
    };
  },
  methods: {
    amIVisible(text) {
      const permissions = (localStorage.getItem("permissions") || "").split(
        ";"
      );
      return permissions.some((x) => x == text);
    },
    getDefaultClient() {
      return window["customerDefault"];
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    logout() {
      localStorage.clear();
      this.$router.push({ name: "login" });
    },
  },
  mounted() {
    EventBus.$on("lookForProduct", (id) => {
      this.$refs.lookForProduct.openProduct(id);
    });
  },
};
</script>
<style lang="scss">
.search-prod {
  position: fixed;
  bottom: 25px;
  right: 5px;
}
.download-apk {
  // position: fixed;
  // bottom: 50px;
  // left: 37px;
  width: 150px;
  height: 150px;
  background-size: contain;
  background-image: url("http://api.hometroc.tn/static/qrcode.png");
}
.download-apk-txt {
  // position: fixed;
  // bottom: 30px;
  // left: 40px;
  max-width: 150px;
  text-align: center;
  font-size: 9px;
}
.logo-home {
  img {
    width: 180px;
  }
}
</style>
